import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClient, getBaseUrlVersioned } from "../../../services/axiosClient";
import { AxiosError } from "axios";
import { API_VERSION } from "../../types";
export const BLOCKED_CREATORS_PAGE_LIMIT = 25;
const fetchBlockedCreatorsPage = createAsyncThunk("blockedCreators/fetchPage", async (args, thunkAPI) => {
    try {
        const limit = args?.limit ?? BLOCKED_CREATORS_PAGE_LIMIT;
        const params = { limit };
        if (args?.lastKey) {
            params["lastKey"] = JSON.stringify(args.lastKey);
        }
        const response = await axiosClient.get(`${getBaseUrlVersioned(API_VERSION.V2)}/users/blocked-creators`, {
            params,
        });
        return response.data;
    }
    catch (error) {
        throw thunkAPI.rejectWithValue(error?.response?.data || "Failed to fetch blocked creators");
    }
});
export default fetchBlockedCreatorsPage;
